<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import AuLogoSimple from '~/components/utils/AuLogoSimple.vue'

const { t } = useI18n()
</script>

<template>
  <div class="flex w-full justify-center py-8">
    <a
      href="/"
      class="inline-flex focus-visible:ring"
      :aria-label="t('home')"
    >
      <AuLogoSimple class="tex-seagreen-50 h-10 w-auto" />
    </a>
  </div>
</template>
